import React, { useEffect, useRef, useState } from "react";
import MisCutVideoMessageBar from "./MixCutVideoMessageBar/MisCutVideoMessageBar";
import Title from "../UIComponents/Title/Title";
import MixCutConfigWrapper from "../UIComponents/MixCutConfigWrapper/MixCutConfigWrapper";
import { IconLoading } from "@arco-design/web-react/icon";
import { getEditingPreview } from "@/services/videoallyis";
import { useParams } from "react-router-dom";
import useMixCutDetailMsg from "@/useStore/mixCutDetail/useMixCutDetailMsg";
import mixCutDetailCheck from "@/useStore/mixCutDetail/mixCutDetailCheck";
import useMixCutDetail from "@/useStore/mixCutDetail/useMixCutDetail";
import Player from "@/components/UI/Player/index";
import { InputNumber, Select } from "@arco-design/web-react";
import usePreviewConfig from "@/useStore/preview/usePreview";
import { combTimeline } from "@/utils/perm";
import previewConfing from "@/stores/previewStore";
import { observer } from "mobx-react";
import clipIdStore from "@/stores/previewStore/clipId";
import usePreviewInfo from "@/useStore/mixCutDetail/usePreviewInfo";
import preivewInfoStore from "@/stores/mixCutDetailStore/previewInfo";
import mixCutDetailStore from "@/stores/mixCutDetailStore";
import ConfigStore from "@/stores/mixedConfig";
import "./PreviewingVideo.less";
import { getScale } from "@/pages/VideoClips/MixCutDetail/VideoCoverConfig/enum";
import useCoverAndBg from "@/useStore/mixCutDetail/useCoverAndBg";
import { enumRatio } from "@/utils/tool";
const { Option } = Select;
const PreviewingVideo = observer(() => {
  const { handleDecorationChange } = useCoverAndBg();
  const { timer, maxCount } = usePreviewInfo();
  const { id } = useParams();
  const { mixCutDetailMsg, handleChangeMixCutDetailMsg } = useMixCutDetailMsg();
  const canvasRef = useRef<HTMLCanvasElement>(null);
  const {
    confirmCaptionsErrorIsEmpty,
    confirmSencesErrorIsEmpty,
    checkJson,
    combSenceMaterials,
  } = mixCutDetailCheck();
  const { toIdAndConfigSetSetting } = usePreviewConfig();
  const { handleGetOriginJson } = useMixCutDetail();
  const [loading, setLoading] = useState(false);
  const [timeLine, setTimeLine] = useState<any>(null);
  const [cutResult, setCutResult] = useState(0);
  const [aspectRatio, setAspectRatio] = useState(mixCutDetailMsg?.aspect);
  const playerRef = useRef<any>(true);

  useEffect(() => {
    handlePreview();
  }, [previewConfing.version]);

  useEffect(() => {
    handlePreview();
  }, [
    ConfigStore.global_settings.decorations,
    ConfigStore.global_settings.background.color,
    ConfigStore.global_settings.background.images,
    ConfigStore.global_settings.background.blur.radius,
  ]);

  // 预览配置
  const handlePreview = () => {
    console.log(JSON.stringify(previewConfing.getMaterial()), "测试");
    setTimeLine({
      timeline: combTimeline(
        previewConfing.getMaterial(),
        previewConfing.getCaption(),
        previewConfing.getTitle()
      ),
    });
  };
  const parseJsonToTimeLine = async () => {
    checkJson();
    const result = combSenceMaterials(handleGetOriginJson());
    setCutResult(result);
    if (confirmCaptionsErrorIsEmpty() && confirmSencesErrorIsEmpty()) {
      try {
        setLoading(true);
        const result = await getEditingPreview({
          project_id: Number(mixCutDetailMsg.project_id),
          session_id: Number(id),
          data: JSON.stringify(handleGetOriginJson()),
        });
        console.log(result.timeline, "result.timeline");
        setTimeLine(JSON.parse(result.timeline));
      } catch (e) {
        console.log(e);
      } finally {
        setLoading(false);
      }
    }
  };
  const changeRatio = (e: any) => {
    console.log(e, "e");
    setAspectRatio(e);
    handleChangeMixCutDetailMsg({ ...mixCutDetailMsg, aspect: e });
    clipIdStore.setClipId(null);
    if (
      ConfigStore.global_settings.enabled &&
      ConfigStore.global_settings.decorations?.length > 0
    ) {
      ConfigStore.global_settings.decorations.map((item) => {
        item.settings.height = getScale(
          item.settings.real_width,
          item.settings.real_height,
          e
        );
        return item;
      });
    }
    handleDecorationChange(ConfigStore.global_settings.decorations);
  };

  // 直接绘制测试线条
  const drawTestLines = () => {
    const canvas = canvasRef.current;
    if (!canvas) return;

    const ctx = canvas.getContext("2d");
    if (!ctx) return;

    // 清除画布
    ctx.clearRect(0, 0, canvas.width, canvas.height);

    // 设置测试线条样式
    ctx.strokeStyle = "#ff0000";
    ctx.lineWidth = 1;
    ctx.globalAlpha = 1.0;
    ctx.setLineDash([5, 5]);

    // 获取容器宽度和高度
    const containerWidth = 360; // 固定宽度为360px
    const containerHeight = 640; // 固定高度为640px

    // 绘制左侧辅助线（距离左边缘25px）
    ctx.beginPath();
    ctx.moveTo(25, 0);
    ctx.lineTo(25, containerHeight);
    ctx.stroke();

    // 绘制右侧辅助线（距离右边缘25px）
    ctx.beginPath();
    ctx.moveTo(containerWidth - 25, 0);
    ctx.lineTo(containerWidth - 25, containerHeight);
    ctx.stroke();
  };

  // 初始化canvas并绘制辅助线，同时监听窗口大小变化
  useEffect(() => {
    // 初始化canvas尺寸
    if (canvasRef.current) {
      canvasRef.current.width = enumRatio(aspectRatio).w;
      canvasRef.current.height = enumRatio(aspectRatio).h;
      // 直接调用函数绘制辅助线
      drawTestLines();
    }

    // 监听窗口大小变化，重新绘制辅助线
    const handleResize = () => {
      if (canvasRef.current) {
        canvasRef.current.width = enumRatio(aspectRatio).w;
        canvasRef.current.height = enumRatio(aspectRatio).h;
        drawTestLines();
      }
    };

    window.addEventListener("resize", handleResize);

    // 清理函数
    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, [aspectRatio]);

  return (
    <MixCutConfigWrapper
      style={{
        boxSizing: "border-box",
        width: 400,
        borderTop: "none",
        overflowY: "auto",
      }}
    >
      <Title title="配置预览" desc="即时查看视频配置效果"></Title>
      <div className="video-wrapper" id="video-wrapper-preview">
        <canvas
          ref={canvasRef}
          className="canvas-preview"
          style={{
            position: "absolute",
            pointerEvents: "none",
            zIndex: 90,
            top: (640 - enumRatio(aspectRatio).h) / 2,
            left: 0,
            backgroundColor: "transparent",
          }}
        />
        {loading ? (
          <div className="loading-wrapper">
            <IconLoading style={{ color: "white", fontSize: 30 }} />
            <p>后台正在解析，请稍后</p>
          </div>
        ) : (
          <></>
        )}
        {
          <>
            <>
              {
                <Player
                  previewInfo={timeLine}
                  clipWatch={(id, config) => {
                    console.log(
                      "clipWatch----------------------",
                      timeLine,
                      id,
                      config
                    );
                    toIdAndConfigSetSetting(id, config);
                    handlePreview();
                  }}
                  aspectRatio={mixCutDetailMsg?.aspect}
                  clipId={clipIdStore.getClipId()}
                  PlayerFunRef={playerRef}
                />
              }
            </>
          </>
        }
      </div>
      <div className="preview-select-wrapper">
        {playerRef.current?.aspectRatioOptions ? (
          <>
            <span>切换比例：</span>
            <Select
              placeholder="选择比例"
              style={{ width: 100 }}
              onChange={(e) => {
                changeRatio(e);
              }}
              value={mixCutDetailMsg?.aspect}
            >
              {playerRef.current?.aspectRatioOptions.map((option) => (
                <Option key={option} value={option}>
                  {option}
                </Option>
              ))}
            </Select>
          </>
        ) : (
          <></>
        )}
        <span style={{ marginLeft: "10px" }}>产出数量：</span>
        <InputNumber
          placeholder="请输入产出数量"
          min={1}
          max={1000}
          value={mixCutDetailStore.outputCount}
          onChange={(e) => {
            mixCutDetailStore.outputCount = e;
          }}
          style={{ width: 100 }}
        />
      </div>

      <MisCutVideoMessageBar
        videoNum={maxCount || 0}
        maxDuration={timer.maxDuration}
        minDuration={timer.minDuration}
      />
    </MixCutConfigWrapper>
  );
});

export default PreviewingVideo;
